import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import Divider from '@mui/material/Divider';
import moment from 'moment';
import PropTypes from 'prop-types';
import {AgyleDragIcon, AgyleResetStateIcon} from '../icons/agyle';
import {Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    filterModal: {
        position: 'absolute',
        right: '15px',
        marginTop: 5,
        zIndex: 99,
        pointerEvents: 'none',
    },
    filterModalBody: {
        width: ({width}) => width,
        height: ({height}) => height,
        padding: '10px',
        background: theme.palette.background.dialog,
        transform: 'translate(0px, 0px)',
        border: `1px solid ${theme.palette.background.dialogBorder}`,
        borderRadius: 10,
        pointerEvents: 'auto',
    },
    modalDragIcon: {
        display: 'flex',
        cursor: 'move',
        justifyContent: 'flex-end',
        gap: 10,
        '&.close, &.reset': {
            cursor: 'pointer',
        },
    },
    divider: {
        margin: '10px 0',
    },
}));

const DraggableModal = (props) => {
    const {t} = useTranslation();
    const bounds = props.bounds;
    const styleProps = {
        width: props.width,
        height: props.height,
        maxHeight: props.maxHeight,
    };

    const handle = 'draggable-dialog-title-' + moment().unix().toString();

    const classes = useStyles(styleProps);

    return (
        <div className={classes.filterModal}>
            <Draggable
                nodeRef={props.nodeRef}
                handle={('#' + handle)}
                bounds={bounds}
                cancel={'[class*="MuiDialogContent-root"]'}
            >
                <div
                    className={classes.filterModalBody}
                    ref={props.nodeRef}
                >
                    <div
                        id={handle}
                        className={classes.modalDragIcon}
                    >
                        <AgyleDragIcon fontSize="small"/>

                        {props.onReset &&
                            <Tooltip title={t('Resets state')}>
                                <AgyleResetStateIcon
                                    className={clsx(classes.modalDragIcon, 'reset')}
                                    onClick={props.onReset}
                                    fontSize="small"
                                />
                            </Tooltip>
                        }

                        {props.onClose &&
                            <CloseIcon
                                className={clsx(classes.modalDragIcon, 'close')}
                                onClick={props.onClose}
                                fontSize="small"
                            />
                        }
                    </div>

                    <Divider className={classes.divider}/>

                    {props.children}
                </div>
            </Draggable>
        </div>
    );
};

DraggableModal.propTypes = {
    bounds: PropTypes.object,
    nodeRef: PropTypes.any,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClose: PropTypes.func,
    onReset: PropTypes.func,
};

DraggableModal.defaultProps = {
    width: 'auto',
    height: 'auto',
    maxHeight: 'auto',
    onReset: null,
};

export default DraggableModal;